import { useHistory, useRouteMatch } from "react-router-dom";
import { FakeBackLinkWithText } from "../../../components/BackLink";
import { BookingDetails } from "../../../components/Brand/BookingDetails";
import { View } from "../../../components/View";
import styled from "../../../styles";
import { BookingTabs } from "../../../utils/enums";

export interface MatchParams {
  page: BookingTabs;
  id: string | undefined;
}

const Wrap = styled.div`
  background-color: ${(p) => p.theme.color.card.background};
  width: 100%;
  overflow-y: visible;
`;

const BookingDetailsView = () => {
  let idMatch = useRouteMatch<MatchParams>("/b/bookings/:page/:id");
  let history = useHistory();

  if (!idMatch) {
    return <View>Invalid URL</View>;
  }

  const { id, page } = idMatch.params;

  const handleBackClick = () => {
    history.push(`/b/bookings/${page}`);
  };

  return (
    <Wrap>
      <FakeBackLinkWithText
        onClick={handleBackClick}
        margin="l l s"
        text="Back to Bookings"
      />
      <BookingDetails bookingId={id ? id : null} />
    </Wrap>
  );
};

export default BookingDetailsView;
